import React, { useState } from 'react';
import styled from 'styled-components';
import CategoryManager from '../components/CategoryManager/CategoryManager.jsx';
import CategoriaGrupoManager from '../components/CategoriaGrupoManager/CategoriaGrupoManager.jsx';
import { colors } from '../utils/colors.js';

const TabsContainer = styled.div`
  display: flex;
  gap: 8px;
  border-bottom: 2px solid ${colors.gray[100]};
  margin-bottom: 20px;
`;

const Tab = styled.button`
  padding: 10px 20px;
  border: none;
  background: transparent;
  color: ${(props) => (props.$active ? colors.primary[600] : colors.gray[500])};
  font-weight: ${(props) => (props.$active ? '600' : '400')};
  font-size: 14px;
  border-bottom: 2px solid ${(props) => (props.$active ? colors.primary[600] : 'transparent')};
  margin-bottom: -2px;
  cursor: pointer;

  &:hover {
    color: ${colors.primary[600]};
  }
`;

export default function Categories() {
  const [activeTab, setActiveTab] = useState('categorias');

  return (
    <div>
      <TabsContainer>
        <Tab type="button" $active={activeTab === 'categorias'} onClick={() => setActiveTab('categorias')}>
          Categorias
        </Tab>
        <Tab type="button" $active={activeTab === 'grupos'} onClick={() => setActiveTab('grupos')}>
          Grupos
        </Tab>
      </TabsContainer>

      {activeTab === 'categorias' && <CategoryManager />}
      {activeTab === 'grupos' && <CategoriaGrupoManager />}
    </div>
  );
}
